'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const SelectionSetTileContents = renderWithRef('SelectionSetTileContents', null, (o, n)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: [
            'swan-selection-set-tile-contents'
        ],
        props: o,
        children: o.children
    }));

export { SelectionSetTileContents };
